// Phone Verification Feature
// Screens, components, and services for phone number verification

export { PhoneVerificationRequestScreen } from './PhoneVerificationRequestScreen';
export type { PhoneVerificationRequestScreenRef } from './PhoneVerificationRequestScreen';

export { PhoneVerificationConfirmScreen } from './PhoneVerificationConfirmScreen';
export type { PhoneVerificationConfirmScreenRef } from './PhoneVerificationConfirmScreen';

export { PhoneVerificationBanner } from './PhoneVerificationBanner';

export { PhoneVerifiedBadge } from './PhoneVerifiedBadge';

export { requestPhoneVerificationCode, confirmPhoneVerificationCode } from './phoneVerificationService';
